<template>
  <div class="organization-position-right-select">
    <div class="organization-position-right-button">
      <a-button type="primary" @click="() => handleAdd(false)">
        {{ $t('page_organization_new_sub_department') }}
      </a-button>
      <a-button
        type="danger"
        style="width: 88px"
        :disabled="!value.length || editItem.pId == 0"
        @click="() => handleDelete()"
      >
        {{ $t('delete') }}
      </a-button>
      <a-button :disabled="!value.length || editItem.pId == 0" @click="() => handleAdd(true)">
        {{ $t('page_organization_editorial_department') }}
      </a-button>
    </div>
    <div class="organization-position-right-tree" :class="lang==='en_US' ? 'en':''">
      <a-tree
        :tree-data="treeData"
        :defaultExpandedKeys="defaultCheckedKeys"
        :selectedKeys="[this.selectKey]"
        defaultExpandAll
        @select="selectTree"
      />
    </div>
    <add-edit-organization
      :visible="addEditVisible"
      :treeData="treeData"
      :editItem="editItem"
      :isEdit="isEdit"
      @cancel="cancelAdd"
      @save="saveAdd"
    ></add-edit-organization>
  </div>
</template>

<script>
import AddEditOrganization from './AddEditOrganization.vue'
import { OrganizationServiceProxy } from '@/service-proxies/app-v2/system.service-proxies'
import { retry } from 'rxjs/operators'
import { getLocalStorage } from '@/utils/storage'
import { getLocalLanguage } from "@/utils";

const osp = new OrganizationServiceProxy()

export default {
  components: {
    AddEditOrganization
  },
  data() {
    return {
      value: [],
      treeData: [],
      defaultCheckedKeys: [],
      editItem: {},
      selectKey: '',
      addEditVisible: false,
      isEdit: false,
      lang: getLocalLanguage('')
    }
  },
  props: {
    selectTab: {
      type: String,
      default: ''
    }
  },
  watch: {
    selectTab: {
      handler() {
        if (this.selectTab === '1') {
          this.getTreeList()
        }
      },
      deep: true,
      immediate: true
    }
  },
  methods: {
    handleAdd(value) {
      this.isEdit = value
      this.addEditVisible = true
    },
    cancelAdd() {
      this.addEditVisible = false
    },
    saveAdd() {
      this.getTreeList()
      this.addEditVisible = false
    },
    handleDelete() {
      this.$confirm({
        icon: () => <a-icon style="color: #ff0000" type="exclamation-circle" />,
        title: this.$t('page_organization_delete_department'),
        content: this.$t('page_organization_delete_department_tip'),
        onOk: () => {
          osp.remove(this.editItem.key).then(() => {
            this.$message.success(this.$t('page_ops_customer_delete_success'))
            this.getTreeList()
          })
        },
        class: 'test'
      })
    },
    async getTreeList() {
      this.value = []
      this.editItem = {}
      const userInfo = getLocalStorage('USER_INFO')
      const { data } = await osp.tree(userInfo.tenant_id)
      this.treeData = [this.treeNode(data[0])]
      this.defaultCheckedKeys = [data[0].id]
      this.selectKey = data[0].id
      this.$emit('changeCustomer', data[0].id)
    },
    treeNode(res) {
      const node = {
        title: res.title,
        value: res.id,
        key: res.id,
        pId: res.parentId,
        children: []
      }
      if (res.children && res.children.length) {
        for (let i = 0; i < res.children.length; i++) {
          node.children.push(this.treeNode(res.children[i]))
        }
      }
      return node
    },
    selectTree(value, node) {
      if (value.length === 0) {
        return
      }
      this.value = value
      this.editItem = node.node.dataRef
      this.selectKey = this.editItem.key
      this.$emit('changeCustomer', this.editItem.key)
    }
  }
}
</script>

<style lang="less" scoped>
.organization-position-right-select {
  height: calc(100% - 46px);
  padding: 8px 6px;
  .organization-position-right-button {
    display: flex;
    align-items: center;
    justify-content: space-between;
    justify-content: flex-start;
    flex-wrap: wrap;

    button {
      margin-bottom: 8px;
    }
  }
  .organization-position-right-tree {
    height: calc(100% - 40px);
    border: 1px solid #d7d7d7;
    overflow-y: auto;
    overflow-x: hidden;

    &.en {
      height: calc(100% - 80px);
    }
  }
}
/deep/ .ant-tree li .ant-tree-node-content-wrapper.ant-tree-node-selected {
  width: 100%;
  background-color: #fff1b8;
}
/deep/ .ant-tree li .ant-tree-node-content-wrapper {
  width: 100%;
}
</style>
